import React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as organizationSelectors from '../../selectors/organizationSelectors';
import * as userSelectors from '../../selectors/userSelectors';

const AppInitLoading = ({ isLoading, classes }) => {
    if (!isLoading) {
        return null;
    }
    return (
        <div className={classes.wrapper}>
            <CircularProgress />
        </div>
    );
};

const mapStateToProps = state => {
    return {
        isLoading:
            organizationSelectors.getIsLoadingOrganizations(state) ||
            userSelectors.getIsLoadingCurrentUser(state),
    };
};

const style = () => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export default connect(mapStateToProps)(injectSheet(style)(AppInitLoading));



// WEBPACK FOOTER //
// ./src/containers/appInitLoading/AppInitLoading.js